import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { hasViewAppointmentPermission } from '../../permission-utils/appointment';
import RadiologyMenu from './RadiologyMenu';

const ExecutiveAssistantMenu = () => {
	const staff = useSelector(state => state.user.profile);

	return (
		<>
			{hasViewAppointmentPermission(staff.permissions) && (
				<li>
					<Link to="/front-desk/appointments/queue">
						<div className="icon-w">
							<div className="os-icon os-icon-calendar-time" />
						</div>
						<span>Appointments</span>
					</Link>
				</li>
			)}
			<li>
				<Link to="/doctor/bookings/pending">
					<div className="icon-w">
						<div className="icon-feather-home" />
					</div>
					<span>Bookings</span>
				</Link>
			</li>
			<li>
				<Link to="/doctor/appointment-history">
					<div className="icon-w">
						<div className="os-icon os-icon-calendar-time" />
					</div>
					<span>Appointment History</span>
				</Link>
			</li>
			<li>
				<Link to="/front-desk/patients">
					<div className="icon-w">
						<div className="os-icon os-icon-cv-2" />
					</div>
					<span>All Patients</span>
				</Link>
			</li>
			<li>
				<Link to="/front-desk/admitted">
					<div className="icon-w">
						<div className="icon-feather-folder-plus" />
					</div>
					<span>Admitted Patients</span>
				</Link>
			</li>
			<li>
				<Link to="/front-desk/opd-patients">
					<div className="icon-w">
						<div className="icon-feather-folder-plus" />
					</div>
					<span>UNREG Patients</span>
				</Link>
			</li>
			<li>
				<Link to="/procedure/all-request">
					<div className="icon-w">
						<div className="os-icon os-icon-newspaper" />
					</div>
					<span>Procedure Requests</span>
				</Link>
			</li>
			<li className="sub-header">
				<span>RADIOLOGY</span>
			</li>
			<li>
				<Link to="/radiology">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Dashboard</span>
				</Link>
			</li>
			<li className="sub-header">
				<span>NURSING</span>
			</li>
			<li>
				<Link to="/nicu">
					<div className="icon-w">
						<div className="os-icon os-icon-documents-03" />
					</div>
					<span>NICU</span>
				</Link>
			</li>
			<li>
				<Link to="/ivf">
					<div className="icon-w">
						<div className="os-icon os-icon-documents-07" />
					</div>
					<span>IVF</span>
				</Link>
			</li>
			<li>
				<Link to="/antenatal/enrolled">
					<div className="icon-w">
						<div className="os-icon os-icon-documents-13" />
					</div>
					<span>Antenatal</span>
				</Link>
			</li>
		</>
	);
};

export default ExecutiveAssistantMenu;
